module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"mother-name":"Nome da mãe"},"en-US":{"mother-name":"Mother\u0027s Name"}}')
  delete Component.options._Ctor
}
